import {
    GET_RESERVATIONS,
    LOGOUT_USER,
    SET_ACTIVE_USER_ORG
} from '../actions/types';

import {
    all,
    fork,
    take,
    takeLatest,
    put,
    cancelled,
    race
} from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';

import { db } from 'config/firebase';

import {
    getReservationsFailure,
    getReservationsSuccess
} from '../actions/Reservations';
import {
    collection,
    getDoc,
    onSnapshot,
    query,
    where
} from '@firebase/firestore';

const reservationsCollectionRef = collection(db, 'reservations');

export function* reservationsCollectionWatch({ payload }) {
    let unsubscribeReservationsData;
    const reservationsCollectionChannel = eventChannel(emit => {
        const reservationsQuery = query(
            reservationsCollectionRef,
            where('org_id', '==', payload)
        );
        unsubscribeReservationsData = onSnapshot(reservationsQuery, snapshot => {
            const reservations = snapshot.docs.map(doc => doc.data());
            emit(reservations);
        });
        return unsubscribeReservationsData;
    });
    try {
        while (true) {
            const { userSignOut, resettingOrg, reservationData } = yield race({
                userSignOut: take(LOGOUT_USER),
                resettingOrg: take(SET_ACTIVE_USER_ORG),
                reservationData: take(reservationsCollectionChannel)
            });

            if (userSignOut || resettingOrg) {
                reservationsCollectionChannel.close();
            } else {
                yield put(getReservationsSuccess(reservationData));
            }
        }
    } catch (error) {
        yield put(getReservationsFailure(error));
    } finally {
        if (yield cancelled()) {
            reservationsCollectionChannel.close();
        }
    }
}

export function* getReservationsCollections() {
    try {
        const querySnapshot = yield getDoc(reservationsCollectionRef);

        const allReservations = querySnapshot.docs.map(doc => doc.data());
        yield put(getReservationsSuccess(allReservations));
    } catch (error) {
        console.error('Error fetching reservations:', error);
        yield put(getReservationsFailure(error));
    }
}

export function* getAllReservations() {
    yield takeLatest(GET_RESERVATIONS, getReservationsCollections);
}

export default function* rootSaga() {
    yield all([
        fork(getAllReservations)
    ]);
}
